import {gql} from "@apollo/client";

export const UPDATE_ORGANIZATION_LOGO = gql`
    mutation UpdateOrganizationLogo($organizationId: ID!, $file: Upload!) {
        updateOrganizationLogo(organizationId: $organizationId, file: $file) {
            success
            errors
            organization {
                id
                logoUrl
            }
        }
    }
`;